function OficinaMobilidadeEventOpen(){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oficina Mobilidade',
    'eventAction': 'Oficina Mobilidade - Open',
    'eventLabel': 'Oficina Mobilidade Open',
  });
}

function OficinaMobilidadeReadingTime(time){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oficina Mobilidade',
    'eventAction': 'Oficina Mobilidade - Reading Time',
    'eventLabel': time,
  });

  gtag('event', 'Oficina Mobilidade', {
    'eventAction': 'Oficina Mobilidade - Reading Time',
    'eventLabel': time,
  });

}

function OficinaMobilidadeReadingProgress(percentage){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oficina Mobilidade',
    'eventAction': 'Oficina Mobilidade - Reading Progress',
    'eventLabel': percentage+"%",
  });

  gtag('event', 'Oficina Mobilidade', {
    'eventAction': 'Oficina Mobilidade - Reading Progress',
    'eventLabel': percentage+"%",
  });
}

$('.banner-shortcode').on('click', function (){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oficina Mobilidade',
    'eventAction': 'Clique - Banner',
    'eventLabel': 'Oficina Mobilidade Clique Banner',
  });

  gtag('event', 'Oficina Mobilidade', {
    'eventAction': 'Clique - Banner',
    'eventLabel': 'Oficina Mobilidade Clique Banner',
  });
});

$('#oficina-mobi-close-button, #oficina-mobi-close').on('click', function (){
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Oficina Mobilidade',
    'eventAction': 'Clique - Fechar',
    'eventLabel': 'Oficina Mobilidade Clique Fechar',
  });

  gtag('event', 'Oficina Mobilidade', {
    'eventAction': 'Clique - Fechar',
    'eventLabel': 'Oficina Mobilidade Clique Fechar',
  });
});


